<template>
    <Modal v-model="show" title="账号信息" :width="400" @on-visible-change="onShowChange">
        <Spin v-if="innerSpin" size="large" fix></Spin>
        <Form ref="userCustomerManagerForm" :model="userCustomerManagerForm" :rules="ruleValidate" label-position="top"
            class="small-form">
            <Row :gutter="18">
                <Col span="20">
                <FormItem label="登录帐号" prop="userName">
                    <Input v-model="userCustomerManagerForm.userName" readonly></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="18">
                <Col span="20">
                <FormItem label="姓名" prop="userCustomerManagerName">
                    <Input v-model="userCustomerManagerForm.userCustomerManagerName
                        " readonly></Input>
                </FormItem>
                </Col>

            </Row>
            <Row :gutter="18">

                <Col span="20">
                <FormItem label="用友部门" prop="userCustomerManagerYsDeptCode">
                    <Select v-model="userCustomerManagerForm.userCustomerManagerYsDeptCode
                        " clearable filterable @on-select="onSelectYSDept">
                        <Option v-for="item in YSDeptOptions" :key="item.code" :value="item.code">{{ item.code }}-{{
                            item.name }}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row>
        </Form>

        <div slot="footer">
            <Button type="primary" v-if="$checkAccessArray(['R','S'])" @click="onSave">确认</Button>
            <Button type="error" @click="show = false">取消</Button>
        </div>
    </Modal>
</template>

<script>
import {
    APPROVAL_NO,
    APPROVAL_YES,
    approvalFormat,
    REGION_GRADE_PROVINCE,
    REGION_GRADE_CITY,
    REGION_GRADE_AREA,
    regionGradeFormat
} from "@/libs/baseModelFormat";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
import SingleFileUploadWithName from "@/components/single-file-upload-with-name/SingleFileUploadWithName";

import {
    customerManagerUserYsDeptSave,
    getCustomerManagerUserDetail,
    pageInit4UserCustomerManagerEdit,
    getManagerRegionList,
    addManagerRegion,
    deleteManagerRegion
} from "@/api/modules/account-management/customerManager-user-management";
import { getYSDeptList } from "@/api/modules/system-management/seedFarm-management";
import { webGetAllRegion } from "@/api/modules/system-management/region-management";
import { getDepartmentList } from "@/api/modules/system-management/department-management";
import search from "@/libs/search";
import { getCustomerMgrCompanyList } from "@/api/modules/account-management/customerManager-user-management";
export default {
    name: "CustomerManagerUserEdit",
    components: {
        SingleFileUploadWithName
    },
    data() {
        return {
            serviceAreaFormShow: false,
            serviceAreaForm: {
                managerUuid: "",
                regionGrade: 3,
                provinceUuid: "",
                cityUuid: "",
                provinceUuids: [],
                cityUuids: [],
                regionUuids: []
            },
            allRegions: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            companyOptions: [],
            deptOptions: [],
            serviceAreaList: [],
            show: false,
            innerSpin: false,
            accountUuid: "",
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userCustomerManagerForm: {
                userCustomerManagerLoginUuid: "",
                userName: "",
                userCustomerManagerName: "",
                userCustomerManagerAreaUuid: "",
                userCustomerManagerContactNumber: "",
                userCustomerManagerPhone: "",
                userCustomerManagerWechat: "",
                userCustomerManagerEmail: "",
                userCustomerManagerApproval: APPROVAL_NO,
                userCustomerManagerCode: "",
                userCustomerManagerPassAll: 0,
                userCustomerManagerWechatFile: "",
                userCustomerManagerYsDeptId: "",
                userCustomerManagerYsDeptCode: "",
                userCustomerManagerYsDeptName: "",
                company: "",
                department: ""
            },
            bindInfo: {
                company: "",
                dept: ""
            },
            ruleValidate: {

                userCustomerManagerYsDeptCode: [
                    {
                        required: true,
                        message: "YS部门不能为空",
                        trigger: "change"
                    }
                ]

            },
            password: "",
            passwordConfirm: "",
            areaSource: [],
            approvalSource: [],
            regionGradeList: [],
            regionTable: {
                columns: [
                    { title: "省份", key: "provinceName", align: "center" },
                    { title: "城市", key: "cityName", align: "center" },
                    { title: "区县", key: "areaName", align: "center" },
                    {
                        title: "服务区域等级",
                        key: "regionGrade",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "span",
                                    {},
                                    regionGradeFormat(params.row.regionGrade)
                                )
                            ]);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "createTime",
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.createTime)
                    },
                    {
                        title: "更新时间",
                        key: "modifyTime",
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.modifyTime)
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small"
                                        },
                                        style: {
                                            display: this.$checkAccessArray([
                                                "S"
                                            ])
                                                ? "inline-block"
                                                : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteManagerRegion(
                                                    params.row
                                                );
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }
                ]
            },
            YSDeptOptions: []
        };
    },
    mounted() {
        this.init();
        this.getYSDeptList();
    },
    methods: {
        onRegionGradeChange() { },
        // 添加服务区域
        addServiceArea() {
            let that = this;
            that.innerSpin = true;
            addManagerRegion(that.serviceAreaForm).then((res) => {
                that.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: "保存服务区域成功",
                        onOk: () => {
                            that.getManagerRegionList(that.accountUuid);
                        }
                    });
                }
            });
        },
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(accountUuid, company = [], dept = []) {
            this.accountUuid = accountUuid;
            this.deptOptions = dept;
            this.companyOptions = company;
            // console.log("companyOptions", this.companyOptions);
            // console.log("deptOptions", this.deptOptions);
            // console.log(company);
            // console.log(dept);
            this.show = true;
        },
        init() {
            this.approvalSource = [];
            this.approvalSource.push({
                val: APPROVAL_NO,
                label: approvalFormat(APPROVAL_NO)
            });
            this.approvalSource.push({
                val: APPROVAL_YES,
                label: approvalFormat(APPROVAL_YES)
            });

            this.regionGradeList = [];
            this.regionGradeList.push({
                val: REGION_GRADE_PROVINCE,
                label: regionGradeFormat(REGION_GRADE_PROVINCE)
            });
            this.regionGradeList.push({
                val: REGION_GRADE_CITY,
                label: regionGradeFormat(REGION_GRADE_CITY)
            });
            this.regionGradeList.push({
                val: REGION_GRADE_AREA,
                label: regionGradeFormat(REGION_GRADE_AREA)
            });

            this.innerSpin = true;
            this.getRegionList();
            pageInit4UserCustomerManagerEdit()
                .then((res) => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.areaSource = res.data.area.records.map((item) => {
                            return {
                                areaUuid: item.areaUuid,
                                areaName: item.areaName
                            };
                        });

                        // const query = this.$route.query;
                        if (this.accountUuid) {
                            this.serviceAreaFormShow = true;
                            this.formEditMode = FORM_EDIT_MODE_MODIFY;
                            this.serviceAreaForm.managerUuid = this.accountUuid;
                            getCustomerManagerUserDetail(this.accountUuid).then(
                                (detail) => {
                                    if (detail.code === 0) {
                                        const info
                                            = detail.data.userCustomerManager;
                                        this.userCustomerManagerForm
                                            = Object.assign(
                                                this.userCustomerManagerForm,
                                                info
                                            );
                                    }
                                }
                            );
                            this.getManagerRegionList(this.accountUuid);
                        }
                        else {
                            this.serviceAreaFormShow = false;
                            this.serviceAreaList = [];
                            this.$refs.userCustomerManagerForm.resetFields();
                        }
                    }
                })
                .catch(() => {
                    this.innerSpin = false;
                });
        },
        getRegionList() {
            webGetAllRegion().then((res) => {
                if (res.code === 0) {
                    this.allRegions = res.data.allRegions;
                    this.provinceOptions = this.allRegions.filter(
                        (r) => r.regionType === 1
                    );
                    this.cityOptions = [];
                    this.distOptions = [];
                }
            });
        },
        onProvinceChange(provinceUuid) {
            this.serviceAreaForm.cityUuids = [];
            this.serviceAreaForm.regionUuids = [];
            this.distOptions = [];

            this.serviceAreaForm.cityUuid = "";
            this.cityOptions = this.allRegions.filter(
                (r) => r.regionType === 2 && r.regionParentUuid === provinceUuid
            );
        },
        onCityChange(cityUuid) {
            this.serviceAreaForm.regionUuids = [];
            this.distOptions = this.allRegions.filter(
                (r) => r.regionType === 3 && r.regionParentUuid === cityUuid
            );
        },
        getManagerRegionList(managerUuid) {
            this.innerSpin = true;
            getManagerRegionList({ managerUuid: managerUuid }).then((res) => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.serviceAreaList = res.data.records;
                }
            });
        },
        deleteManagerRegion(row) {
            this.$Modal.confirm({
                title: "是否确认删除该服务区域？",
                onOk: () => {
                    this.innerSpin = true;
                    deleteManagerRegion({
                        managerRegionUuid: row.managerRegionUuid
                    }).then((res) => {
                        this.innerSpin = false;
                        if (res.code === 0) {
                            this.getManagerRegionList(row.managerUuid);
                        }
                    });
                }
            });
        },
        onSave() {
            this.$refs.userCustomerManagerForm.validate((valid) => {
                if (!valid) {
                    this.$Message.error("表单验证失败!");
                    return;
                }

                const data = Object.assign(

                    this.userCustomerManagerForm
                );

                this.innerSpin = true;
                customerManagerUserYsDeptSave(data).then((res) => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.show = false;
                                this.$parent.getCustomerManagerUserTableRecords();
                            }
                        });
                    }
                });
            });
        },
        getYSDeptList() {
            getYSDeptList().then((res) => {
                if (res.code == 0) {
                    this.YSDeptOptions = res.data.deptList;
                }
            });
        },
        onSelectYSDept(row) {
            const matchedDept = this.YSDeptOptions.find(
                (item) => item.code === row
            );
            if (matchedDept) {
                this.userCustomerManagerForm.userCustomerManagerYsDeptId
                    = matchedDept.id;
                this.userCustomerManagerForm.userCustomerManagerYsDeptName
                    = matchedDept.name;
            }
        },
        onSelectCompany() { },
        onSelectDept() { }
    }
};
</script>

<style scoped></style>
